import { AxiosError } from 'axios';

import { ForbiddenResponseDto } from 'theSource/types';

export const INVALID_CERTIFICATE_ERROR_MESSAGE = 'Invalid Certificate';

export const isSessionExpired = (
  error?: AxiosError<ForbiddenResponseDto>
): boolean =>
  error?.response?.status === 403 &&
  error.response.data.message === INVALID_CERTIFICATE_ERROR_MESSAGE;
